import { IsEmail, IsNumber, IsNumberString, IsOptional } from 'class-validator';

export class GiftCardBalanceResponseDto {
  public cardNumber: string;

  @IsNumber()
  public balance: number;

  @IsEmail()
  @IsOptional()
  public customerEmail?: string;

  @IsNumber()
  @IsOptional()
  public cvvCode?: number;

  constructor(
    cardNumber: string,
    balance: number,
    customerEmail?: string,
    cvvCode?: number
  ) {
    this.cardNumber = cardNumber;
    this.balance = balance;
    this.customerEmail = customerEmail;
    this.cvvCode = cvvCode;
  }
}
